import type {
  B2bRecurringInvestmentAllocationSourceValues,
  B2bRecurringInvestmentPayerValues,
  B2bRecurringInvestmentStatusValues,
} from '@Common/types/bo/b2b/recurring_investments';
import type { OrderInitiator } from '@Common/types/bo/orders/common';
import type { B2bRecurringInvestmentFrequency } from '@Common/types/explore/mutual_fund_order';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const b2bRecurringInvestmentStatusChoices = makeChoicesCommon<
  (typeof B2bRecurringInvestmentStatusValues)[number]
>()({
  active: 'resources.bo_common.b2b.recurring_investments.status.active',
  deleted: 'resources.bo_common.b2b.recurring_investments.status.deleted',
});

export const b2bRecurringInvestmentFrequencyChoices =
  makeChoicesCommon<B2bRecurringInvestmentFrequency>()({
    weekly: 'resources.bo_common.b2b.recurring_investments.frequency.weekly',
    monthly: 'resources.bo_common.b2b.recurring_investments.frequency.monthly',
    quarterly: 'resources.bo_common.b2b.recurring_investments.frequency.quarterly',
    semi_annually: 'resources.bo_common.b2b.recurring_investments.frequency.semi_annually',
    yearly: 'resources.bo_common.b2b.recurring_investments.frequency.yearly',
  });

export const b2bRecurringInvestmentPayerChoices = makeChoicesCommon<
  (typeof B2bRecurringInvestmentPayerValues)[number]
>()({
  employee: 'resources.bo_common.b2b.recurring_investments.payer.employee',
  company: 'resources.bo_common.b2b.recurring_investments.payer.company',
});

export const b2bRecurringInvestmentInitiatorChoices = makeChoicesCommon<OrderInitiator>()({
  user: 'resources.bo_common.b2b.recurring_investments.initiator.user',
  shares: 'resources.bo_common.b2b.recurring_investments.initiator.shares',
  broker: 'resources.bo_common.b2b.recurring_investments.initiator.broker',
  bo: 'resources.bo_common.b2b.recurring_investments.initiator.bo',
});

export const b2bRecurringInvestmentAllocationSourceChoices = makeChoicesCommon<
  (typeof B2bRecurringInvestmentAllocationSourceValues)[number]
>()({
  allocation: 'resources.bo_common.b2b.recurring_investments.allocations.source.allocation',
  managed_grid: 'resources.bo_common.b2b.recurring_investments.allocations.source.managed_grid',
});
